import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';
import Store from '@/store.js';
import { BASE_URL } from "@/helpers/Constants";
import type { StoreState } from '@/store.types';

Vue.use(Router);
Vue.use(VueResource);

type HttpMethod = 'get' | 'post' | 'put' | 'delete';
type RequestData = Record<string, unknown> | string | unknown[] | {};

interface HttpResponse {
  statusText?: string;
  status?: number;
  ok?: boolean;
  body?: any;
}

interface HttpRequest {
  headers: { set(name: string, value: string): void };
}

interface HttpClient {
  interceptors: Array<(request: HttpRequest, next: () => void) => void>;
  [method: string]: any;
}

const http = (Vue as unknown as { http: HttpClient }).http;
const storeState = (Store as unknown as { state: StoreState }).state;

export default {
  processRequest(url: string = '', method: HttpMethod = 'get', data: RequestData = {}): Promise<HttpResponse> {
    Store.commit("addRequest");
    Store.commit('showLoader', true);

    url = BASE_URL + url;

    if (url !== '/MediaLibrary' && method !== 'post') {
      data = JSON.stringify(data);
    }

    http.interceptors.push((request, next) => {
      request.headers.set("Authorization", localStorage.token);
      next();
    });

    return http[method](
      url,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then((response: HttpResponse) => {
        Store.commit("removeRequest");
        if (storeState.activeRequests === 0) {
          Store.commit("showLoader", false);
        }
        return response;
      },
      (response: HttpResponse) => {
        Store.commit("removeRequest");
        if (storeState.activeRequests === 0) {
          Store.commit("showLoader", false);
        }
        if (response && response.statusText && response.statusText === "Unauthorized") {
          localStorage.removeItem('token');
          window.location.href = "/#/";
        }
        if (response && response.body && response.body.message && response.body.message === "Not Authenticated") {
          localStorage.removeItem('token');
          window.location.href = "/#/";
        } else if (response && response.body && response.body.message && response.body.message === "access denied") {
          window.location.href = "/#/published";
          alert('You haven\'t access to this route. Please connect to site admin!');
        } else {
          Store.commit('showLoader', false);
          return response;
        }
      });
  },
  getAllImages() {
    return http.get(BASE_URL + `/MediaLibrary/GetImages/Image?mallId=${localStorage.mallId}`).then(
      (response: HttpResponse) => {
        if (response.body && response.body.success) {
          alert(response.body.message);
        } else {
          return response.body;
        }
      },
      (response: HttpResponse) => {
        console.log(response);
        alert("Error during request!");
      });
  },
  async postSlideshowContent(id: string | number, model: RequestData): Promise<HttpResponse> {
    // eslint-disable-next-line no-return-await
    return await http.post(BASE_URL + `/Slideshow/${id}?mallId=${localStorage.mallId}`, model);
  },
  deleteSlideshow(id: string | number): Promise<HttpResponse> {
    return http.delete(BASE_URL + '/Slideshow?id=' + id);
  },
};
